"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdown = void 0;
const border_1 = require("./border");
const colors_1 = require("./colors");
exports.dropdown = {
    states: {
        active: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.Select.enabled}`,
        },
        disabled: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.Select.disabled}`,
            color: `${colors_1.colors.neutral.colorLight}`,
            background: 'none',
        },
        enabled: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.Select.enabled}`,
        },
        error: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.Select.error}`,
        },
        locked: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.neutral.colorMedium}`,
            cursor: 'default',
            '&:hover': {
                borderColor: `${colors_1.colors.neutral.colorMedium}`,
            },
        },
        selected: {
            borderBottom: `${border_1.border.width.borderXs} ${border_1.border.style.solid} ${colors_1.colors.Select.enabled}`,
        },
    },
};
//# sourceMappingURL=dropdown.js.map